import { createContext } from "react";
import DocumentsStore from './store'

const store = new DocumentsStore();
const DocumentsStoreContext = createContext<DocumentsStore>(store);
export default DocumentsStoreContext;
